export default defineAppConfig({
  ui: {
    colors: {
      primary: 'blue',
      secondary: 'blue',
      neutral: 'slate',
      success: 'emerald',
      info: 'sky',
      warning: 'amber',
      error: 'rose',
    },
  },
});
